import { GridRow } from '@/components/ui/layouts/grids/GridRow';
import { Section } from '@/components/ui/layouts/sections/Section';

import { gridRow } from '@mage-ui/styled-system/recipes';
import { Instances } from '../Instances';

export const CardsBlock = ({ data }) => {
  return (
    <Section
      heading={{
        epi: data?.fields?.epi || null,
        title: data?.fields?.title || null,
        intro: data?.fields?.intro || null,
      }}
    >
      <GridRow
        className={gridRow({
          colGapM: 'gap800',
          colGapL: 'gap900',
        })}
      >
        <Instances instances={data?.relations?.CardsList} />
      </GridRow>
    </Section>
  );
};
